import { State } from 'src/types'
import { thumbHook } from 'src/features/dxm/drawer/rightThrow/catcher/back/thumbHook'
import { littleHook } from 'src/features/dxm/drawer/rightThrow/catcher/back/littleHook'
import { laceDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/lace'
import { liningDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/liningDrawer'
import { backStyleDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/backStyleDrawer'
import { canvasResetter } from 'src/util/canvas'
import { catchFaceDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/catchFaceDrawer'
import { webDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/webDrawer'
import { fingerEmbroideryDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/fingerEmbroideryDrawer'
import { fingerGuardDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/fingerGuardDrawer'
import { dxmLabel } from '../../glove/back/label'

export const dxmCanvasCatcherMittBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  // リセット
  canvasResetter(ctx)

  // 裏革
  liningDrawer(ctx, state)

  // バックスタイル
  backStyleDrawer(ctx, state)

  // 捕球面側
  catchFaceDrawer(ctx, state.catchFace.color, state.stitch.color, state.baseModel.productNumber)

  // 指カバー・指当て
  fingerGuardDrawer(ctx, state)

  // 親指、小指の刺繍
  fingerEmbroideryDrawer(ctx, state.embroideries)

  // ウェブ
  webDrawer(ctx, state)

  // 革紐
  laceDrawer(ctx, state.lace.color)

  // かけ紐
  thumbHook(ctx, state.thumbHook.color)
  littleHook(ctx, state.littleHook.color)

  // ブランドのラベル
  dxmLabel(ctx, state, 8, 115, 0, 0.9)
}
